import { render } from "./CancelbillReport.vue?vue&type=template&id=680f6eb6"
import script from "./CancelbillReport.vue?vue&type=script&lang=js"
export * from "./CancelbillReport.vue?vue&type=script&lang=js"

import "./CancelbillReport.vue?vue&type=style&index=0&id=680f6eb6&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__